import ActionClienteSet from "../ActionClienteSet";
import { TipoDeCliente, TipoDeDoc, Sexo } from "../../../../isp.žapi.clientes/constantesApiClientes";


export default class SetTipoCliente extends ActionClienteSet{

    darleUnNuevoValorALaPropiedadDelaNuevaEntidad(estado, nuevoEstado) {
        nuevoEstado.domain.screen.tipoCliente = this.payload;
        if (this.payload === TipoDeCliente.DocId ) {
            new ActionClienteSet("tipoDoc",TipoDeDoc.DNI).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nroDoc","").ejecutar(estado, nuevoEstado);
            new ActionClienteSet("apellidos","").ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nombres","").ejecutar(estado, nuevoEstado);
            new ActionClienteSet("sexo",Sexo.SinDef).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("razonSocial",null).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("ruc",null).ejecutar(estado, nuevoEstado);

        } else {
            new ActionClienteSet("tipoDoc",null).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nroDoc",null).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("apellidos",null).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nombres",null).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("sexo",null).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("razonSocial","").ejecutar(estado, nuevoEstado);
            new ActionClienteSet("ruc","").ejecutar(estado, nuevoEstado);
            
        }
        // this.cargarElRestoDeCamposAlCambiarTipoCliente(estado, nuevoEstado);
    }

    hacerALaPropiedadIgualASuVersionCargadaCuandoNoloEraAntes(estado, nuevoEstado) {
        nuevoEstado.domain.screen.tipoCliente = estado.domain.cargado.tipoCliente;
        delete nuevoEstado.domain.update.tipoCliente;
        nuevoEstado.domain.nroUpdates--;

        new ActionClienteSet("tipoDoc",estado.domain.cargado.tipoDoc).ejecutar(estado, nuevoEstado);
        new ActionClienteSet("nroDoc",estado.domain.cargado.nroDoc).ejecutar(estado, nuevoEstado);
        new ActionClienteSet("apellidos",estado.domain.cargado.apellidos).ejecutar(estado, nuevoEstado);
        new ActionClienteSet("nombres",estado.domain.cargado.nombres).ejecutar(estado, nuevoEstado);
        new ActionClienteSet("sexo",estado.domain.cargado.sexo).ejecutar(estado, nuevoEstado);
        new ActionClienteSet("razonSocial",estado.domain.cargado.razonSocial).ejecutar(estado, nuevoEstado);
        new ActionClienteSet("ruc",estado.domain.cargado.ruc).ejecutar(estado, nuevoEstado);
        
        /*if (estado.domain.cargado.tipoCliente === TipoDeCliente.DocId ) {
            // delete nuevoEstado.domain.update.razonSocial;
            // delete nuevoEstado.domain.update.ruc;
            
            new ActionClienteSet("tipoDoc",estado.domain.cargado.tipoDoc).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nroDoc",estado.domain.cargado.nroDoc).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("apellidos",estado.domain.cargado.apellidos).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nombres",estado.domain.cargado.nombres).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("sexo",estado.domain.cargado.sexo).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("razonSocial",estado.domain.cargado.razonSocial).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("ruc",estado.domain.cargado.ruc).ejecutar(estado, nuevoEstado);
        } else {
            // delete nuevoEstado.domain.update.tipoDoc;
            // delete nuevoEstado.domain.update.nroDoc;
            // delete nuevoEstado.domain.update.apellidos;
            // delete nuevoEstado.domain.update.nombres;
            // delete nuevoEstado.domain.update.sexo;
            new ActionClienteSet("tipoDoc",estado.domain.cargado.tipoDoc).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nroDoc",estado.domain.cargado.nroDoc).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("apellidos",estado.domain.cargado.apellidos).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nombres",estado.domain.cargado.nombres).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("sexo",estado.domain.cargado.sexo).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("razonSocial",estado.domain.cargado.razonSocial).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("ruc",estado.domain.cargado.ruc).ejecutar(estado, nuevoEstado);
        }*/
    }

    hacerALaPropiedadDiferenteDeSuVersionCargadaPorPrimeraVez(estado, nuevoEstado) {
        nuevoEstado.domain.screen.tipoCliente = this.payload;
        if(this.payload!==null){
            nuevoEstado.domain.update.tipoCliente = this.payload;
            nuevoEstado.domain.nroUpdates++;
        }
        if (this.payload === TipoDeCliente.DocId ) {
            // delete nuevoEstado.domain.update.razonSocial;
            // delete nuevoEstado.domain.update.ruc;
            new ActionClienteSet("tipoDoc",TipoDeDoc.DNI).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nroDoc","").ejecutar(estado, nuevoEstado);
            new ActionClienteSet("apellidos","").ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nombres","").ejecutar(estado, nuevoEstado);
            new ActionClienteSet("sexo",Sexo.SinDef).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("razonSocial",estado.domain.cargado.razonSocial).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("ruc",estado.domain.cargado.ruc).ejecutar(estado, nuevoEstado);
        } else {
            // delete nuevoEstado.domain.update.tipoDoc;
            // delete nuevoEstado.domain.update.nroDoc;
            // delete nuevoEstado.domain.update.apellidos;
            // delete nuevoEstado.domain.update.nombres;
            // delete nuevoEstado.domain.update.sexo;
            new ActionClienteSet("tipoDoc",estado.domain.cargado.tipoDoc).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nroDoc",estado.domain.cargado.nroDoc).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("apellidos",estado.domain.cargado.apellidos).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("nombres",estado.domain.cargado.nombres).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("sexo",estado.domain.cargado.sexo).ejecutar(estado, nuevoEstado);
            new ActionClienteSet("razonSocial","").ejecutar(estado, nuevoEstado);
            new ActionClienteSet("ruc","").ejecutar(estado, nuevoEstado);
        }   
    }

    hacerALaPropiedadDiferenteDeSuVersionCargadaPorEnesimaVez(estado, nuevoEstado) {
        //Solo hay dos Tipos de Cliente: ConDoc y Ruc, y no puede ser nulo, cuando haya un tercero implementaré este método
    }

    /* cargarElRestoDeCamposAlCambiarTipoCliente(estado, nuevoEstado){
        if (this.payload === TipoDeCliente.DocId ) {
            new SetTipoDoc(TipoDeDoc.DNI).ejecutar(estado, nuevoEstado);
            new SetNroDoc("").ejecutar(estado, nuevoEstado);
            new SetNombres("").ejecutar(estado, nuevoEstado);
            new SetApellidos("").ejecutar(estado, nuevoEstado);
            new SetSexo("").ejecutar(estado, nuevoEstado);
        } else {
            new SetRazonSocial("").ejecutar(estado, nuevoEstado);
            new SetNroRUC("").ejecutar(estado, nuevoEstado);
        }
    } */
    /* ejecutar(estado, nuevoEstado){

        nuevoEstado.domain.tipoCliente = this.payload;
        
        if (nuevoEstado.domain.tipoCliente === TipoDeCliente.DocId ) {
            new SetTipoDoc(TipoDeDoc.DNI).ejecutar(estado, nuevoEstado);
            new SetNroDoc("").ejecutar(estado, nuevoEstado);
            new SetNombres("").ejecutar(estado, nuevoEstado);
            new SetApellidos("").ejecutar(estado, nuevoEstado);
            new SetSexo("").ejecutar(estado, nuevoEstado);
        } else {
            new SetRazonSocial("").ejecutar(estado, nuevoEstado);
            new SetNroRUC("").ejecutar(estado, nuevoEstado);
        }

        //Efectos Colaterales
        return this.continuarCambiosEnEstado(estado, nuevoEstado,"tipoCliente");
    } */
}